import script from "./SupportFAQ.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupportFAQ.vue?vue&type=script&setup=true&lang=ts"

import "./SupportFAQ.vue?vue&type=style&index=0&id=830bcdb0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-830bcdb0"]])

export default __exports__